export enum ApprovalState {
  IMPORTED = 'IMPORTED',

  DRAFT = 'DRAFT',

  CURATED = 'CURATED',

  REVIEWED = 'REVIEWED',
}
